import styled from 'styled-components';

export const RunOption = styled.div`
  display: flex;
`;

export const RunOptionLabel = styled.div`
  flex: 1 1 auto;
`;
